import { Box, Chip } from "@mui/material"
import { AutocompleteRenderGetTagProps } from "@mui/material/Autocomplete"

interface IMemberTag {
  id: number
  first_name: string
  last_name: string
}

export const GROUP_MEMBERS_TAGS_MAX_HEIGHT = "210px"

export const renderGroupMemberTags = (
  focused: boolean,
  members: IMemberTag[],
  getTagProps: AutocompleteRenderGetTagProps
) => {
  const chips = members.map((option, index) => (
    <Chip
      label={`${option.first_name} ${option.last_name}`}
      {...getTagProps({ index })}
      key={option.id}
    />
  ))

  if (!focused) {
    return chips
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignContent: "flex-start",
        flex: "1 1 auto",
        minWidth: 0,
        maxHeight: GROUP_MEMBERS_TAGS_MAX_HEIGHT,
        overflowY: "auto",
      }}
    >
      {chips}
    </Box>
  )
}
